import { callFunction } from './functionsClient';
import type { UserProfile, PaymentRequest, TokenPackage } from '../types';

export const adminApi = {
  listUsers: (search?: string, before?: number) =>
    callFunction<{ items: UserProfile[]; nextCursor: number | null }>(
      'list-users',
      { query: { search, before } },
    ),
  banUser: (uid: string) =>
    callFunction<{ user: UserProfile }>('ban-user', { method: 'POST', body: { uid } }),
  unbanUser: (uid: string) =>
    callFunction<{ user: UserProfile }>('unban-user', { method: 'POST', body: { uid } }),
  adjustBalance: (uid: string, amount: number, reason: string) =>
    callFunction<{ transaction: { id: string; amount: number; balanceAfter: number } }>(
      'adjust-balance',
      { method: 'POST', body: { uid, amount, reason } },
    ),
  createAdmin: (uid: string) =>
    callFunction<{ user: UserProfile }>('create-admin', { method: 'POST', body: { uid } }),
  listPaymentRequests: (status = 'pending') =>
    callFunction<{ items: PaymentRequest[] }>('list-payment-requests', {
      query: { status },
    }),
  reviewPayment: (requestId: string, decision: 'approve' | 'reject', reason?: string) =>
    callFunction<{ request: { id: string; status: string } }>('review-payment', {
      method: 'POST',
      body: { requestId, decision, reason },
    }),
  managePackage: (pkg: Partial<TokenPackage> & { name: string; tokenAmount: number; priceDisplay: string; active: boolean }) =>
    callFunction<{ package: TokenPackage }>('manage-packages', {
      method: 'POST',
      body: pkg,
    }),
  managePaytable: (gameSlug: string, oddsConfig: Record<string, unknown>) =>
    callFunction<{ payTable: unknown }>('manage-paytable', {
      method: 'POST',
      body: { gameSlug, oddsConfig },
    }),
  toggleGame: (gameSlug: string, enabled: boolean) =>
    callFunction<{ game: unknown }>('toggle-game', {
      method: 'POST',
      body: { gameSlug, enabled },
    }),
  toggleMaintenance: (enabled: boolean) =>
    callFunction<{ settings: unknown }>('toggle-maintenance', {
      method: 'POST',
      body: { enabled },
    }),
  dashboardSummary: () =>
    callFunction<{
      totalPurchased: number;
      totalWagered: number;
      totalPaidOut: number;
      activeUsers: number;
    }>('dashboard-summary'),
};
